import classnames from 'classnames';
import type { VoidFunctionComponent } from 'react';
import type { RevisionLicense } from '../../../models/revisionlicense/types';
import List from '../generic/List';
import Tooltip from '../generic/Tooltip';
import { getNormalizedLicense } from './utils';

const MAX_VISIBLE_LICENSES_PER_ROW = 3;

/**
 * Generic component for rendering licenses across package inventory.
 * Renders the first nth licenses and then a "show more" which can be hovered.
 */
export const PackageInventoryLicenses: VoidFunctionComponent<{
  licenses: Array<Pick<RevisionLicense, 'licenseGroupId' | 'licenseId'>>;
  hasDarkBackground?: boolean;
}> = ({ licenses, hasDarkBackground = false }) => {
  const normalizedLicense = getNormalizedLicense(licenses, MAX_VISIBLE_LICENSES_PER_ROW);
  const extraLicenseCount = normalizedLicense.licenseCount - MAX_VISIBLE_LICENSES_PER_ROW;
  const licenseCountClassName = classnames('package-inventory__metadata-licenses__extra-license-count', {
    'package-inventory__metadata-licenses__extra-license-count--dark': hasDarkBackground,
  });

  return (
    <Tooltip
      tooltip={normalizedLicense.fullLicenseText}
      id="package-license-tooltip"
      showTooltip={extraLicenseCount > 0}
    >
      <span className="inline-block">
        <List.RowDetailsItem>
          <span className="package-inventory__metadata-licenses">
            <span className="package-inventory__metadata-licenses__text">
              {normalizedLicense.partialLicenseText}
            </span>
            {extraLicenseCount > 0 && (
              <div className={licenseCountClassName}>
                <span className="package-inventory__metadata-licenses__extra-license-count__label">
                  + {extraLicenseCount} more
                </span>
              </div>
            )}
          </span>
        </List.RowDetailsItem>
      </span>
    </Tooltip>
  );
};
